import React, { useState, useEffect } from "react";
import AddCardModal from "./AddCardModal";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import ErrorPage from "../../Components/ErrorPage";
import LoadingBilling from "./LoadingBilling";
import { useNavigate } from "react-router-dom";
import AddCreditsModal from "./AddCreditsModal";
import { TbPencil } from "react-icons/tb";

const MainBilling = () => {
    const navigate = useNavigate()
    const user_id = sessionStorage.getItem("user_id");
    const [openBillingItem, setOpenBillingItem] = useState(false);
    const [cardModal, openCardModal] = useState(false);
    const [billingData, setBillingData] = useState(null);
    const [paymentData, setPaymentData] = useState({});
    const [transactions, setTransactions] = useState({})
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false)
    const [animateReset, setAnimateReset] = useState(false)
    const [creditBalance, setCreditBalance] = useState(0)
    const [showAddCredits, setShowAddCredits] = useState(false)
    const [paymentSettings, setPaymentSettings] = useState({})

    const test_stripe = "pk_test_51RU6Q7GwIOZks56fh1QyjQfqeNQNG6XuqAhKUujCKuJzrd4t45toMk7F58pN2Qrb2mtMVd0GGwIyIE2YjTjKJUxa00RjClmNw8"
    const prod_stripe = "pk_live_51RU6Q7GwIOZks56fg4G48srkSo7NqKfnDemTYJwmJKJug0tFjLkivLHBRTjtzTIQKc0fsTmvbRtvHdx0Zj5AuzsA00o6ZnIc6L"
    const stripePromise = loadStripe(test_stripe);

    useEffect(() => {
        if (!user_id) {
            // setLoading(false);
            setAnimateReset(false)
            return;
        }
        fetchBilling();
    }, [user_id]);

    const fetchBilling = async () => {
        setAnimateReset(true)
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_billing", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id }),
            });

            if (!response.ok) throw new Error("Failed to fetch billing info");

            const data = await response.json();
            console.log(data.transactions)
            setBillingData(data.payment_method || null);
            setTransactions(data.transactions)
            setCreditBalance(data.credit_balance || 0)
            setPaymentSettings(data.payment_settings)
        } catch (error) {
            setBillingData(null);
            setError(true)
            setAnimateReset(false)
        } finally {
            setTimeout(() => {
                setLoading(false);
                setAnimateReset(false)
            }, 800);
        }
    };

    const toggleDetails = () => {
        setOpenBillingItem((prev) => !prev);
    };

    const hasPaymentMethod = billingData && Object.keys(billingData).length > 0;
    const currentDate = new Date();
    const currentMonthString = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}`;

    const totalCurrentUsage = (() => {
        const monthData = paymentData?.databases?.[currentMonthString];
        if (!monthData) return 0;

        return Object.values(monthData)
            .filter(entry => typeof entry === "object" && entry.total_amount)
            .reduce((sum, entry) => sum + (parseFloat(entry.total_amount) || 0), 0);
    })();


    const usageCurrency = paymentData?.databases?.[currentMonthString]?.[0]?.currency || "$";

    const paymentMethods = billingData || {};
    const card = paymentMethods.card_details || {};
    const { brand, exp_month, exp_year, last4 } = card;
    const name = paymentMethods.name || "";
    const surname = paymentMethods.surname || "";

    const formattedExpDate = exp_month && exp_year
        ? `${exp_month.toString().padStart(2, "0")}/${exp_year.toString().slice(-2)}`
        : "";

    const openInvoice = (invoice_id) => {
        window.open(`/invoice/${invoice_id}`, '_blank');
    };

    if (error) {
        return <ErrorPage />;
    }


    return (
        <Elements stripe={stripePromise}>
            <div className="middle_cont_main fade-in">
                <div className="main_view_title main_view_title_billing">
                    Billing
                    <div>
                        <button className="reload_billing_btn" onClick={fetchBilling}>
                            <i className={`fa-solid fa-arrows-rotate ${animateReset ? "activated_animation" : ""}`}></i>
                        </button>
                        {/* <button className="reload_billing_btn" onClick={() => setShowAddCredits(true)}><i className="fa-solid fa-plus"></i> Add credits</button> */}
                    </div>
                </div>
                <p className="main_view_subtitle">Billing and payments</p>

                {loading ? (
                    <LoadingBilling />
                ) : (
                    <div className="billing_container_main fade-in">
                        {!hasPaymentMethod ? (
                            <div className="no_card fade-in" onClick={() => openCardModal(true)}>
                                <p>No card available</p>
                                <button className="add_card_btn">Add new card</button>
                            </div>
                        ) : (
                            <div className="card_resume_container">
                                <div className="card_resume">
                                    <div className="card_header">
                                        <p>{`${name} ${surname}`}</p>
                                        <p>{brand ? brand.charAt(0).toUpperCase() + brand.slice(1) : ""}</p>
                                    </div>
                                    <div className="card_body">
                                        <p>{last4 ? `**** **** **** ${last4}` : "**** **** **** ****"}</p>
                                        <p>{formattedExpDate}</p>
                                    </div>
                                    <div className="card_footer">
                                        <div className="card_footer_ribbon"></div>

                                    </div>
                                </div>
                                {/* <div className="new_payment_method" onClick={() => openCardModal(true)}>
                                    <i><TbPencil /></i>
                                </div> */}
                            </div>
                        )}

                        <div className="billing_container">
                            <div className={`billing_item ${openBillingItem ? "open_billing_item" : ""}`}>
                                <div className="header_billing_item">
                                    <p>Transactions</p>
                                    <div className="header_billing_details">

                                        <p className="see_det_billing" onClick={toggleDetails}>
                                            See details{" "}
                                            <i className={`fa-solid ${openBillingItem ? "fa-chevron-up" : "fa-chevron-down"}`} />
                                        </p>
                                    </div>
                                </div>
                                <div className="body_billing_details">
                                    {transactions && Object.keys(transactions).length > 0 ? (
                                        <div className="billing_details_list">
                                            {transactions && Object.keys(transactions).length > 0 ? (
                                                Object.entries(transactions)
                                                    .sort(([, a], [, b]) => new Date(b.timestamp) - new Date(a.timestamp)) // newest first
                                                    .map(([trnsId, trns]) => (
                                                        <div key={trnsId} className="billing_detail_item">
                                                            <span title={trns.item} className="billing_item_span">{trns.item}</span>
                                                            <span title={trns.transaction} className="billing_item_span">
                                                                {trns.transaction == "add_credit" ? (
                                                                    <>New credit</>
                                                                ) : (
                                                                    <>Usage</>
                                                                )}

                                                            </span>
                                                            <span title={trns.amount} className="billing_item_span">
                                                                {trns.currency == "USD" ? (
                                                                    <>$</>
                                                                ):(
                                                                    <>USD</>
                                                                )}
                                                                {parseFloat(trns.amount) > 0 && parseFloat(trns.amount) < 0.01
                                                                    ? "0.01"
                                                                    : parseFloat(trns.amount).toFixed(2)}{" "}
                                                                
                                                            </span>
                                                            {/* <span title={trns.status} className="billing_item_span">
                                                                {trns.status
                                                                    ? trns.status.charAt(0).toUpperCase() + trns.status.slice(1)
                                                                    : ""}
                                                            </span> */}
                                                            <span className="billing_message">{trns.payment_description}</span>
                                                            {/* <button onClick={() => openInvoice(trns._id)}>View Invoice</button> */}
                                                        </div>
                                                    ))
                                            ) : (
                                                <div className="no_billing_cont_mex">You don't have any active transactions...</div>
                                            )}
                                        </div>

                                    ) : (
                                        <div className="no_billing_cont_mex">You don't have any active resources...</div>
                                    )}
                                </div>
                            </div>
                            <div className="billing_item">
                                <div className="header_billing_item">
                                    <p>Credits</p>
                                    <p className="price_billing">{creditBalance.toFixed(2)} {usageCurrency}</p>
                                </div>
                            </div>
                            <div className="billign_item_info">
                                {/* <p className="billing_pricing_info_message">All new users get $15 worth of credits to use across the Erioon resources.</p> */}
                                <p className="billing_pricing_info_message">
                                    If your services exceed your available credits, the excess amount will be automatically charged to your saved payment method.
                                </p>
                                <p className="billing_pricing_info_message">
                                    Invoices are issued every time you purchase new credits or when excess usage is charged to your payment method.
                                </p>
                                <p className="billing_pricing_info_message">Pricing information may not update immediately and could take some time to reflect changes.</p>
                                <p className="billing_pricing_info_message">Having trouble with billing or payments? We're here to help — just open a <span className="link_ticket_billing" onClick={() => navigate("/control_panel/support/new-ticket")}>support ticket</span></p>
                            </div>
                        </div>
                    </div>
                )}

                <AddCardModal show={cardModal} handleClose={() => openCardModal(false)} fetchBilling={fetchBilling} />
                <AddCreditsModal show={showAddCredits} handleClose={() => setShowAddCredits(false)} fetchBilling={fetchBilling} hasPaymentMethod={hasPaymentMethod} last4={last4} formattedExpDate={formattedExpDate} brand={brand} openCardModal={openCardModal} paymentSettings={paymentSettings}/>
            </div>
        </Elements>
    );
};

export default MainBilling;
